var scope_0 = require('/home/runner/work/coqui-ai.github.io/coqui-ai.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/358e8a190e3f2840090c8cbe1446440b.js').default;export default
        Object.assign({}, scope_0 )
    